export function CreateEventModal({ isSaving, minEndDate, setMinEndDate, onClose, onSubmit }) {
  return (
    <div className="modal-overlayAdmin">
      <div className="modal-contentAdmin">
        <div className="modal-header">
          <h3>Event Management</h3>
          <button className="close-button" onClick={onClose}>&times;</button>
        </div>
        <form className="modal-form" onSubmit={onSubmit}>
          <div className="form-group">
            <label>Event Title</label>
            <input name="title" type="text" placeholder="Enter event title..." required />
          </div>
          <div className="Section_Date">
            <div className="date-field">
              <label>Location Name:</label>
              <input name="locationName" type="text" placeholder="Place name..." />
            </div>
            <div className="date-field">
              <label>Address :</label>
              <input name="address" type="text" placeholder="Full address" />
            </div>
          </div>
          <div className="Section_Date">
            <div className="date-field">
              <label>Event Date Start</label>
              <input name="startDate" type="date" required onChange={(e) => setMinEndDate(e.target.value)} />
            </div>
            <div className="date-field">
              <label>Start Time</label>
              <input name="startTime" type="time" required />
            </div>
          </div>
          <div className="Section_Date">
            <div className="date-field">
              <label>Event Date End</label>
              <input name="endDate" type="date" required min={minEndDate} />
            </div>
            <div className="date-field">
              <label>End Time</label>
              <input name="endTime" type="time" required />
            </div>
          </div>
          <div className="form-group">
            <label>Event Description</label>
            <textarea name="description" rows="4" placeholder="Describe the event..." required></textarea>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn-cancel" onClick={onClose} disabled={isSaving}>Cancel</button>
            <button type="submit" className="btn-save" disabled={isSaving}>
              {isSaving ? "Creating..." : "Create Event"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}